/* Rozana Bazaar - product page image arrows + swipe */
(function () {
  var css =
    '.pg-main{position:relative;}' +
    '.pg-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:40px;height:40px;border-radius:50%;border:1px solid #E4E2D8;background:rgba(255,255,255,.95);color:#0B3D2E;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;box-shadow:0 4px 14px rgba(0,0,0,.2);transition:background .15s,color .15s;}' +
    '.pg-arrow:hover{background:#0B3D2E;color:#fff;}' +
    '.pg-arrow svg{width:18px;height:18px;}' +
    '.pg-prev{left:10px;}.pg-next{right:10px;}' +
    '.pg-count{position:absolute;right:10px;bottom:10px;z-index:3;background:rgba(11,61,46,.82);color:#fff;font-size:12px;font-weight:700;padding:3px 10px;border-radius:999px;}' +
    '@media (max-width:640px){.pg-arrow{width:34px;height:34px;}.pg-arrow svg{width:16px;height:16px;}.pg-prev{left:8px;}.pg-next{right:8px;}}';
  var st = document.createElement('style');
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  function init() {
    var main = document.querySelector('.pg-main');
    var img = document.getElementById('pg-main-img');
    var thumbs = document.querySelectorAll('.pg-thumb-btn');
    if (!main || !img || thumbs.length < 2) return;

    function mk(cls, label, path) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pg-arrow ' + cls;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="' + path + '"/></svg>';
      main.appendChild(b);
      return b;
    }
    var prev = mk('pg-prev', 'Previous image', 'M15 5l-7 7 7 7');
    var next = mk('pg-next', 'Next image', 'M9 5l7 7-7 7');
    var count = document.createElement('div');
    count.className = 'pg-count';
    main.appendChild(count);

    function current() {
      var src = img.getAttribute('src');
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('data-full') === src) return i;
      }
      for (var j = 0; j < thumbs.length; j++) {
        if (thumbs[j].classList.contains('active')) return j;
      }
      return 0;
    }
    function show() { count.textContent = (current() + 1) + ' / ' + thumbs.length; }
    function go(delta) {
      var n = (current() + delta + thumbs.length) % thumbs.length;
      thumbs[n].click();
      if (thumbs[n].scrollIntoView) {
        try { thumbs[n].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) {}
      }
      show();
    }
    prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.pg-thumb-btn')) setTimeout(show, 0);
    });

    /* swipe on the main image (mobile) */
    var x0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    }, { passive: true });

    show();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
